"use strict";

import React from "react";
import _ from "lodash";
import MessageUtils from "../utils/MessageUtils";
import LoadingSpinner from "./LoadingSpinner.jsx";
import ShowitNameLogo from "./ShowitNameLogo.jsx";

class SubviewProcessing extends React.Component {
  static defaultProps = {
    showLogo: true,
    message: "Processing...",
  };

  render() {
    const message = this.props.message;

    return (
      <div className={"view-centered"} style={{ flexDirection: "column" }}>
        {this.props.showLogo ? (
          <div className="showitNameLogo">
            <ShowitNameLogo />
          </div>
        ) : null}
        <LoadingSpinner />
        <div style={{ padding: 20, fontSize: 22, fontWeight: 300 }}>{message}</div>
      </div>
    );
  }
}

export default SubviewProcessing;
